<template>
  <div class="wrapper no-scroll-bar">

    <div class="header-wrapper">
      <v-toolbar
        color="primary"
        fixed
        dark
      >
        <v-btn
          @click="routerBack"
          style="position: absolute"
          icon
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-spacer />
        <v-toolbar-title>{{ childName }}</v-toolbar-title>
        <v-spacer />
      </v-toolbar>

      <v-tabs
        v-model="tab"
        background-color="white"
        @change="updateRange"
        fixed
      >
        <v-tab
          v-for="item in tabItems"
          :key="item.tab"
        >
          {{ item.tab }}
        </v-tab>
      </v-tabs>
      <div class="month-menu d-flex align-center justify-space-between">
        <div class="d-flex align-center ml-3">
          <v-btn
            @click="toPrevMonth"
            icon
            class="no-background-hover"
            color="primary"
            dark
          >
            <v-icon>mdi-chevron-left</v-icon>
            <h4 class="primary--text">
              前の月
            </h4>
          </v-btn>
        </div>

        <div class="d-flex align-end">
          <h3>{{ formatedToday }}</h3>
        </div>

        <div class="d-flex align-center mr-3">
          <v-btn
            @click="toNextMonth"
            icon
            class="no-background-hover"
            color="primary"
            dark
          >
            <h4 class="primary--text">
              次の月
            </h4>
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </div>
      </div>
    </div>

    <div class="scroll-wrapper no-scroll-bar">


      <v-tabs-items class="scroll-item" v-model="tab">
        <v-tab-item
          v-for="item in tabItems"
          :key="item.tab"
        >
          <v-card flat>


            <v-sheet height="400">
              <v-calendar
                ref="record_calendar"
                :now="today"
                :value="today"
                :events="events"
                @change="updateRange"
                @click:event="showEvent"
                @click:date="showEvent"
                event-color="primary"
                color="primary"
                locale="ja-jp"
                :day-format="timestamp => new Date(timestamp.date).getDate()"
                :month-format="timestamp => (new Date(timestamp.date).getMonth() + 1) + ' /'"
              >
              </v-calendar>
            </v-sheet>
          </v-card>
        </v-tab-item>
      </v-tabs-items>


      <div class="nursery-title title-wrapper pa-1 px-3">
        <h5>園での記録</h5>
      </div>

      <vue-loading
        v-if="fetchLoading"
        type="bubbles"
        color="#EE6090"
        :size="{ width: '50px', height: '50px' }"
      ></vue-loading>

      <div v-else>

        <div class="subtitle-wrapper pa-1 px-3">
          <h5>喫食</h5>
        </div>
        <div class="d-flex flex-wrap">
          <div
            class="pa-1"
            v-for="m in meals"
            :key="m.key"
          >
            <eating-status-item
              :text="m.text"
              :item="m.item"
            />
          </div>
        </div>

        <div class="subtitle-wrapper pa-1 px-3">
          <h5>排便</h5>
        </div>
        <div
          class="d-flex pa-2"
          v-for="d in nursery.defecations"
          :key="d.defecationId"
        >
          <p class="grey--text text--darken-1 mr-2">
            {{ minuteFormat(d.recordedAt) }}
          </p>
          <p>{{ getDefecationState(d.state) }}</p>
        </div>

        <div class="subtitle-wrapper pa-1 px-3">
          <h5>ミルク</h5>
        </div>
        <div
          class="d-flex pa-2"
          v-for="m in nursery.milks"
          :key="m.milkId"
        >
          <p class="grey--text text--darken-1 mr-2">
            {{ minuteFormat(m.recordedAt) }}
          </p>
          <p>{{ m.amount }}cc</p>
        </div>

        <div class="subtitle-wrapper pa-1 px-3">
          <h5>体温</h5>
        </div>
        <div
          class="d-flex pa-2"
          v-for="t in nursery.temperatures"
          :key="t.temperatureId"
        >
          <p class="grey--text text--darken-1 mr-2">
            {{ minuteFormat(t.recordedAt) }}
          </p>
          <p>{{ t.temperature }}℃</p>
        </div>

      </div>


      <div class="title-wrapper pa-1 px-3">
        <h5>家庭での記録</h5>
      </div>

      <vue-loading
        v-if="fetchLoading"
        type="bubbles"
        color="#EE6090"
        :size="{ width: '50px', height: '50px' }"
      ></vue-loading>

      <div v-else>

        <div class="subtitle-wrapper pa-1 px-3">
          <h5>睡眠時間</h5>
        </div>
        <div
          class="d-flex pa-2"
          v-for="s in home.sleeps"
          :key="s.sleepId + s.createdAt"
        >
          <p>{{ minuteFormat(s.from) }} 〜 {{ minuteFormat(s.to) }}</p>
        </div>

        <div class="subtitle-wrapper pa-1 px-3">
          <h5>体温</h5>
        </div>
        <div
          class="d-flex pa-2"
          v-for="t in home.temperatures"
          :key="t.temperatureId + t.createdAt"
        >
          <p class="grey--text text--darken-1 mr-2">
            {{ minuteFormat(t.recordedAt) }}
          </p>
          <p>{{ t.temperature }}℃</p>
        </div>

        <div class="subtitle-wrapper pa-1 px-3">
          <h5>朝食</h5>
        </div>
        <div
          class="d-flex pa-2"
          v-for="b in home.breakfasts"
          :key="b.breakfastId + b.createdAt"
        >
          <p>{{ b.content }}</p>
        </div>

        <div class="subtitle-wrapper pa-1 px-3">
          <h5>夕食</h5>
        </div>
        <div
          class="d-flex pa-2"
          v-for="d in home.dinners"
          :key="d.dinnerId + d.createdAt"
        >
          <p>{{ d.content }}</p>
        </div>

        <div class="subtitle-wrapper pa-1 px-3">
          <h5>ミルク</h5>
        </div>
        <div
          class="d-flex pa-2"
          v-for="m in home.milks"
          :key="m.milkId + m.createdAt"
        >
          <p class="grey--text text--darken-1 mr-2">
            {{ minuteFormat(m.recordedAt) }}
          </p>
          <p>{{ m.amount }}cc</p>
        </div>

        <div class="subtitle-wrapper pa-1 px-3">
          <h5>排便</h5>
        </div>
        <div
          class="d-flex pa-2"
          v-for="d in home.defecations"
          :key="d.defecationId + d.createdAt"
        >
          <p class="grey--text text--darken-1 mr-2">
            {{ minuteFormat(d.recordedAt) }}
          </p>
          <p>{{ getDefecationState(d.state) }}</p>
        </div>

      </div>

    </div>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from 'vue';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
dayjs.locale('ja');
import { when } from '@/service/Switch';

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

import EatingStatusItem from '@/components/molecules/EatingStatusItem.vue';

import { VCalendar } from '@/model/Vuetify/VCalendar';
import { meModule } from '@/store/entityModules/me';
import { dailyReportModule } from '@/store/entityModules/dailyReport';
import { MilkResponse } from 'chaild-entity/src/component/home/milk/types';
import { DefecationResponse, DefecationStatus, DefecationStatusType } from 'chaild-entity/src/component/home/defecation/types';
import { MealResponse, MealStatus, MealStatusType } from 'chaild-entity/src/component/nursery/meal/types';
import { TemperatureResponse } from 'chaild-entity/src/component/home/temperature/types';

interface Event {
  name: string;
  start: Date;
  end: Date;
  color: string;
  timed: boolean;
}

enum TabType {
  MEAL = 'meal',
  DEFECATION = 'defecation',
  MILK = 'milk',
  TEMPERATURE = 'temperature',
}

interface DataType {
  childId: number;
  childName: string;
  selectedDate: string;
  tab: number | null;
  tabItems: Array<{ tab: string, content: TabType }>;
  events: Event[];
  selectedOpen: boolean;
  selectedEvent: any;
  selectedElement: any | null;
  fetchLoading: boolean;
}

export default defineComponent({

  components: {
    'vue-loading': Loading,
    EatingStatusItem,
  },

  data: (): DataType => ({
    childId: NaN,
    childName: '',
    selectedDate: dayjs().format('YYYY-MM-DD'),
    tab: null,
    tabItems: [
      { tab: '喫食', content: TabType.MEAL },
      { tab: '排便', content: TabType.DEFECATION },
      { tab: 'ミルク', content: TabType.MILK },
      { tab: '体温', content: TabType.TEMPERATURE },
    ],
    events: [],
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    fetchLoading: false,
  }),

  computed: {
    calendar(): VCalendar {
      return (this.$refs as any).record_calendar;
    },
    me() {
      return meModule.me;
    },
    meals() {
      return dailyReportModule.meals;
    },
    reports() {
      return dailyReportModule.reports;
    },
    mealReports() {
      const mealReports: MealResponse[] = [];
      const meals = dailyReportModule.reports.map((r) => {
        if (r.nursery.meal) { return r.nursery.meal; }
      });
      return mealReports;
    },
    defecationReports() {
      const defecationReports: DefecationResponse[] = [];
      const defecations = dailyReportModule.reports.map((r) => {
        const array = r.home.defecations.concat(r.nursery.defecations);
        array.map((d) => {
          defecationReports.push(d);
        });
      });
      return defecationReports;
    },
    milkReports() {
      const milkReports: MilkResponse[] = [];
      const milks = dailyReportModule.reports.map((r) => {
        const array = r.home.milks.concat(r.nursery.milks);
        array.map((m) => {
          milkReports.push(m);
        });
      });
      return milkReports;
    },
    temperatureReports() {
      const temperatureReports: TemperatureResponse[] = [];
      const temperatures = dailyReportModule.reports.map((r) => {
        const array = r.home.temperatures.concat(r.nursery.temperatures);
        array.map((t) => {
          temperatureReports.push(t);
        });
      });
      return temperatureReports;
    },
    home() {
      return dailyReportModule.home;
    },
    nursery() {
      return dailyReportModule.nursery;
    },
    year(): string {
      return dayjs(this.selectedDate).format('YYYY');
    },
    today(): string {
      return dayjs(this.selectedDate).format('YYYY-MM-DD');
    },
    formatedToday(): string {
      return dayjs(this.selectedDate).format('M月');
    },
    dayOfTheWeek(): string {
      return dayjs(this.selectedDate).format('ddd');
    },
  },

  methods: {
    routerBack() {
      this.$router.replace('/record');
    },
    toNextMonth() {
      this.selectedDate = dayjs(this.selectedDate).add(1, 'month').format('YYYY-MM-DD');
      // tslint:disable-next-line
      this.calendar.next;
      this.fetchReportList();
    },
    toPrevMonth() {
      this.selectedDate = dayjs(this.selectedDate).add(-1, 'month').format('YYYY-MM-DD');
      // tslint:disable-next-line
      this.calendar.prev;
      this.fetchReportList();
    },
    async fetchReportList() {
      this.fetchLoading = true;
      const fromDate = dayjs(this.selectedDate).startOf('month');
      const endDate = dayjs(this.selectedDate).endOf('month');
      await dailyReportModule.fetchReportList({
        childId: this.childId,
        from: dayjs(fromDate).format('YYYY-MM-DD'),
        to: dayjs(endDate).format('YYYY-MM-DD'),
      });
      this.updateRange();
      this.fetchLoading = false;
    },
    async showEvent({ nativeEvent, event, date }) {
      if (event) { this.selectedDate = dayjs(event.start).format('YYYY-MM-DD'); }
      if (date) { this.selectedDate = dayjs(date).format('YYYY-MM-DD'); }
      this.fetchLoading = true;
      await dailyReportModule.fetchReport({
        childId: this.childId,
        date: this.selectedDate,
      });
      this.$nextTick(() => {
        this.eventScrollToBottom();
        this.fetchLoading = false;
      });
    },
    eventScrollToBottom() {
      const selectedElement: Element = document.getElementsByClassName('scroll-wrapper')[0];
      const scrollElemnt: Element = document.getElementsByClassName('scroll-item')[0];
      selectedElement.scrollTop = scrollElemnt.clientHeight;
    },
    updateRange() {
      this.events = [];
      const events: Event[] = [];
      when(typeof this.tab === 'number' && this.tabItems[this.tab].content)
        .on((v) => v === TabType.MEAL, () => {
          // for (let i = 0; i < this.mealReports.length; i++) {
          for (const mr of this.mealReports) {
            const date = new Date(dayjs(mr.date).format('YYYY-MM-DD HH:mm:ss'));
            const state = when(mr.stapleFood)
              .on((v) => v === MealStatus.refill, () => 'おかわり')
              .on((v) => v === MealStatus.finished, () => '完食')
              .on((v) => v === MealStatus.unfinished, () => '少し残した')
              .on((v) => v === MealStatus.half, () => '半分食べた')
              .on((v) => v === MealStatus.little, () => '少し食べた')
              .on((v) => v === MealStatus.notEat, () => '食べなかった')
              .on((v) => v === MealStatus.notServed, () => '未提供');
            events.push({
              name: `${state}`,
              start: date,
              end: date,
              color: 'primary',
              timed: false,
            });
          }
        })
        .on((v) => v === TabType.DEFECATION, () => {
          // for (let i = 0; i < this.defecationReports.length; i++) {
          for (const dr of this.defecationReports) {
            const date = new Date(dayjs(dr.recordedAt).format('YYYY-MM-DD HH:mm:ss'));
            const state = when(dr.state)
              .on((v) => v === DefecationStatus.hard, () => '硬い')
              .on((v) => v === DefecationStatus.normal, () => '普通')
              .on((v) => v === DefecationStatus.soft, () => '軟らかい')
              .on((v) => v === DefecationStatus.diarrhea, () => '水様便（下痢）')
              .otherwise(() => '');
            events.push({
              name: `${state}`,
              start: date,
              end: date,
              color: 'primary',
              timed: false,
            });
          }
        })
        .on((v) => v === TabType.MILK, () => {
          // for (let i = 0; i < this.milkReports.length; i++) {
          for (const mr of this.milkReports) {
            const date = new Date(dayjs(mr.recordedAt).format('YYYY-MM-DD HH:mm:ss'));
            events.push({
              name: `${mr.amount}cc`,
              start: date,
              end: date,
              color: 'primary',
              timed: false,
            });
          }
        })
        .on((v) => v === TabType.TEMPERATURE, () => {
          // for (let i = 0; i < this.temperatureReports.length; i++) {
          for (const tr of this.temperatureReports) {
            const date = new Date(dayjs(tr.recordedAt).format('YYYY-MM-DD HH:mm:ss'));
            events.push({
              name: `${tr.temperature}℃`,
              start: date,
              end: date,
              color: 'primary',
              timed: false,
            });
          }
        })
        .otherwise(() => {});
      this.events = events;
    },
    minuteFormat(iso: string) {
      return dayjs(iso).format('HH:mm');
    },
    getDefecationState(state: DefecationStatusType): string {
      return when(state)
        .on((v) => v === DefecationStatus.hard, () => '硬い')
        .on((v) => v === DefecationStatus.normal, () => '普通')
        .on((v) => v === DefecationStatus.soft, () => '軟らかい')
        .on((v) => v === DefecationStatus.diarrhea, () => '水様便（下痢）')
        .otherwise(() => '');
    },
  },

  async mounted() {
    if (typeof this.$route.query.childName === 'string') {
      this.childName = this.$route.query.childName;
    }
    if (typeof this.$route.query.childId === 'string') {
      this.childId = Number(this.$route.query.childId);
      await Promise.all([
        this.fetchReportList(),
        dailyReportModule.fetchReport({
          childId: this.childId,
          date: this.selectedDate,
        }),
      ]);
    } else {
      this.routerBack();
    }
  },
});
</script>
<style lang="scss" scoped>
.wrapper {
  height: 100vh; /* Fallback */
  height: calc(var(--vh, 1vh) * 100);
  // padding: 145px 0 0;
  overflow-y: scroll;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none;

  .header-wrapper {
    height: 181px;
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 3;

    .outline {
      border: 1px solid rgb(var(--v-theme-primary));
    }
    .month-menu {
      background-color: #ffffff;
    }
  }
}
.scroll-wrapper {
  height: calc(calc(var(--vh, 1vh) * 100) - 181px - 56px);
  margin: 181px 0 56px;
  overflow-y: hidden;
}
.title-wrapper {
  color: #ffffff;
  background-color: rgb(var(--v-theme-primary));
}
.subtitle-wrapper {
  color: #A3A4A4;
  background-color: #F5F6F6;
}
.full {
  height: 30px;
  width: 30px;
  border-radius: 100%;
  background-color: rgb(var(--v-theme-primary));
}
</style>
